import { Component, OnInit } from '@angular/core';
import { RestrictService } from '../../Common/Permissions/restrict.service';
import { Constants } from '../../constants.new';
import { UserInstanceService } from '../../User/userInstance.service';

@Component({
    selector: 'help-component',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
    providers: [RestrictService, Constants]
})
export class HelpComponent implements OnInit {
    constructor(private _restrictService: RestrictService,
                private _userInstanceService: UserInstanceService,
                private _constants: Constants) {
    }

    hasViewPermission: boolean = false;
    hasRyanInstanceSelected: boolean = false;

    ngOnInit(): void {
        this.hasViewPermission = this._restrictService.isInRole(this._constants.Roles['RYANPRIVATEITEMSVIEW']) ||
            this._restrictService.isInRole(this._constants.Roles['RYANPRIVATEITEMSEDIT']);
        this.hasRyanInstanceSelected = !!this._userInstanceService.isRyanInstanceSelected();
    }

}
